import { supabase } from '../lib/supabase';
import { Rol } from '../types/auth';

export const rolService = {
  async getAll() {
    const { data, error } = await supabase
      .from('roles')
      .select('*')
      .order('nivel', { ascending: true });

    if (error) {
      throw new Error('Error al obtener roles');
    }

    return data as Rol[];
  },

  async getById(id: string) {
    const { data, error } = await supabase
      .from('roles')
      .select('*')
      .eq('id', id)
      .single();

    if (error) {
      throw new Error('Error al obtener rol');
    }

    return data as Rol;
  },

  async getRolesDisponiblesParaSolicitud(usuarioRolNombre: string) {
    if (usuarioRolNombre === 'Super Admin') {
      const { data, error } = await supabase
        .from('roles')
        .select('*')
        .order('nivel', { ascending: true });

      if (error) {
        throw new Error('Error al obtener roles disponibles');
      }

      return data as Rol[];
    }

    const rolesMap: Record<string, string[]> = {
      'Admin Nacional': ['User Nacional', 'Admin Diocesano', 'User Diocesano', 'Admin Local', 'User Local'],
      'Admin Diocesano': ['User Diocesano', 'Admin Local', 'User Local'],
    };

    const rolesPermitidos = rolesMap[usuarioRolNombre] || [];

    if (rolesPermitidos.length === 0) {
      return [];
    }

    const { data, error } = await supabase
      .from('roles')
      .select('*')
      .in('nombre', rolesPermitidos)
      .order('nivel', { ascending: true});

    if (error) {
      throw new Error('Error al obtener roles disponibles');
    }

    return data as Rol[];
  },
};
